import http from './http'

export function getNotifications (params) {
  return http.get('/notifications', { params: { page: params.page || 0, size: params.size || 20 } }).then(function (res) {
    return res.data
  })
}

export function getUnreadNotifications () {
  return http.get('/notifications/unread').then(function (res) {
    return res.data
  })
}

export function markNotificationRead (id) {
  return http.patch('/notifications/' + id + '/read').then(function () {})
}

export function markAllNotificationsRead () {
  return http.patch('/notifications/read-all').then(function () {})
}
